import * as Icons from 'components/Icons/Icons';

const IconsComponent = () => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, 100px)',
        gap: '16px',
      }}
    >
      {Object.entries(Icons).map(([name, IconComponent]) => (
        <div key={name} style={{ textAlign: 'center' }}>
          <IconComponent />
          <div style={{ fontSize: '12px', marginTop: '8px' }}>{name}</div>
        </div>
      ))}
    </div>
  );
};

export default IconsComponent;
